import React from "react";
import { getClassName } from "@sscs/utils";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneLight } from "react-syntax-highlighter/dist/esm/styles/prism";
import remarkGfm from "remark-gfm";
import { Table } from "../index";
import styles from "./markdownPreview.module.scss";
const markdownComponents = {
    // eslint-disable-next-line id-length
    a: ({ children }) => React.createElement("span", null, children),
    blockquote: ({ children }) => (React.createElement("blockquote", { className: styles.quote }, children)),
    code: ({ className, children }) => {
        var _a, _b;
        const language = (_b = (_a = /language-(\w+)/.exec(className !== null && className !== void 0 ? className : "")) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        return language ? (React.createElement(SyntaxHighlighter, { language: language, style: oneLight }, String(children).replace(/\n$/, ""))) : (React.createElement("code", { className: className }, children));
    },
    pre: ({ children }) => React.createElement("pre", { className: styles["code-block"] }, children),
    table: ({ children }) => (React.createElement(Table.Table, { className: styles.table }, children)),
    thead: ({ children }) => React.createElement(Table.Head, null, children),
    tbody: ({ children }) => React.createElement(Table.Body, null, children),
    tr: ({ children }) => (React.createElement(Table.Row, { className: styles["table-row"] }, children)),
    th: ({ children }) => React.createElement(Table.Cell, null, children),
    td: ({ children }) => (React.createElement(Table.Cell, { className: styles.cell }, children)),
};
const MarkdownPreview = ({ text, className, }) => {
    return (React.createElement("div", { className: getClassName(styles.root, className) },
        React.createElement(ReactMarkdown, { remarkPlugins: [remarkGfm], components: markdownComponents }, text)));
};
export default MarkdownPreview;
//# sourceMappingURL=MarkdownPreview.js.map